$traceurRuntime.ModuleStore.getAnonymousModule(function() {
  "use strict";
  angular.module('app.module').controller('SlideABCDCtrl', (function($rootScope, $scope, $timeout, AudioManager, Analytics, AnswerAPI, TestScore) {
    $scope.api.pushMessageScreen(false, $scope.chapterPagination, "Zit je er klaar voor?", "attention");
    AnswerAPI.reset();
    $rootScope.selectedAnswer = [];
    $rootScope.deselectedAnswers = [];
    $scope.selectAnswer = (function(index, multiple) {
      $rootScope.selectedAnswer = AnswerAPI.select(index, multiple);
      if ($rootScope.selectedAnswer.indexOf(index) < 0) {
        $rootScope.deselectedAnswers.push(index);
      } else if ($rootScope.selectedAnswer.indexOf(index) > -1) {
        if ($rootScope.deselectedAnswers.indexOf(index) > -1) {
          var true_index = parseInt($rootScope.deselectedAnswers.indexOf(index));
          $rootScope.deselectedAnswers.splice(true_index, 1);
        }
      }
      $scope.answerClass = (function(index) {
        var classnames = '';
        if ($rootScope.selectedAnswer.indexOf(index) > -1) {
          classnames += 'is-selected ';
        }
        if (typeof $scope.slide.feedback !== 'undefined' && $scope.slide.feedback.correct instanceof Array) {
          if ($scope.slide.feedback.correct.indexOf(index) > -1) {
            classnames += 'is-correct';
          }
        }
        return classnames;
      });
      if ($scope.isScoreTest) {
        var answer_score = 0;
        if ($rootScope.selectedAnswer.indexOf(index) > -1) {
          answer_score = $scope.isScoreTest[index];
        } else {
          answer_score = -$scope.isScoreTest[index];
        }
        TestScore.add($scope.slideID, answer_score);
      }
    });
    $scope.deselectAnswer = (function(index, multiple) {
      if ($rootScope.deselectedAnswers.indexOf(index) < 0) {
        $rootScope.deselectedAnswers.push(index);
      }
      if ($rootScope.selectedAnswer.indexOf(index) > -1) {
        var true_index = parseInt($rootScope.selectedAnswer.indexOf(index));
        $rootScope.selectedAnswer.splice(true_index, 1);
      }
      AudioManager.play('click_alt');
    });
    function showVoteResults(event, data) {
      $scope.hasVoted = data;
      $scope.stage = 'answered';
    }
    $scope.$on('voteDone', showVoteResults);
    function resetVote() {
      $scope.continue = false;
      $scope.selectedAnswer = false;
      $scope.showAnswer = false;
      $scope.slideObj.stage = 'initial';
    }
    resetVote();
    $scope.$on('resetVote', resetVote);
    $scope.countdown = 15;
  })).controller('SlideResultsCtrl', (function($rootScope, $scope, $timeout, AudioManager, Analytics, TestScore) {
    $scope.api.pushMessageScreen($scope.slide.feedback, 'resultaten', "De uitslag is bekend.", "thumb-up");
    var testScore = TestScore.score();
    $scope.resultFeedback = false;
    $scope.slide.feedback.forEach(function(score) {
      if ((testScore >= score.min) && (testScore <= score.max)) {
        $scope.resultFeedbackTitle = score.title;
        $scope.resultFeedbackExplanation = score.explanation;
      }
    });
  })).controller('SlideStepsCtrl', (function($rootScope, $scope, $timeout, AudioManager, Analytics) {
    $scope.activeStep = 0;
    $scope.goToStep = (function(index) {
      $scope.activeStep = index;
    });
  })).controller('SlideDragDropCtrl', (function($rootScope, $scope, $timeout, AudioManager, Analytics) {
    $rootScope.disabledDrag = false;
    $scope.disabledDrag = false;
    $scope.optionItems = [];
    if ($scope.slide.subtype === 'word-connect') {
      $scope.optionItems = _.pluck($scope.slide.words, 'connection');
      $scope.optionItemsShuffled = _.shuffle($scope.optionItems);
      $scope.originalItems = _.pluck($scope.slide.words, 'label');
      $scope.slide.zones = $scope.originalItems;
      $scope.originals = {
        "type": "fixedzone",
        "title": "Nederlands",
        "items": $scope.originalItems
      };
    }
    if ($scope.slide.subtype === 'image-connect') {
      $scope.optionItems = _.pluck($scope.slide.words, 'label');
      $scope.optionItemsShuffled = _.shuffle($scope.optionItems);
      $scope.originalItems = _.pluck($scope.slide.words, 'image');
      $scope.slide.zones = $scope.originalItems;
      $scope.originals = {
        "type": "fixedzone",
        "title": "Nederlands",
        "items": $scope.originalItems
      };
    }
    if ($scope.slide.subtype === 'sort') {
      $scope.optionItems = _.pluck($scope.slide.words, 'label');
      $scope.optionItemsShuffled = _.shuffle($scope.optionItems);
      $scope.slide.zones = [];
      $scope.slide.zones[0] = 'Sorteer';
    }
    if ($scope.slide.subtype === 'drag-drop') {
      $scope.optionItems = _.pluck($scope.slide.words, 'label');
      $scope.optionItemsShuffled = _.shuffle($scope.optionItems);
    }
    function generateList(options) {
      return options.map(function(option) {
        return {
          labelFunc: function(index) {
            return option;
          },
          label: option
        };
      });
    }
    $scope.options = {
      "type": "dragzone",
      "title": "Sleep mij",
      "items": generateList($scope.optionItemsShuffled)
    };
    $scope.selectedAnswer = [];
    for (var z in $scope.slide.zones) {
      $scope.selectedAnswer[z] = {
        "type": "dropzone",
        "title": $scope.slide.zones[z].title,
        "items": generateList([])
      };
    }
    ;
    $scope.showAnswers = (function(zone, index) {
      if (typeof $scope.feedback != 'undefined' || $scope.feedback) {
        if ($scope.feedback.type === 'too-many-tries' || $scope.feedback.type === 'correct') {
          if ($rootScope.selectedAnswer[zone].items[index].correct) {
            return 'is-correct';
          } else {
            return 'is-wrong';
          }
        }
      }
    });
    $rootScope.$on('checkedAnswer', function(event, correct) {
      $scope.selectedAnswer = correct;
    });
    $rootScope.selectedAnswer = $scope.selectedAnswer;
    $scope.onDrop = function(srcList, srcIndex, targetList, targetIndex) {
      targetList.splice(targetIndex, 0, srcList[srcIndex]);
      if (srcList == targetList && targetIndex <= srcIndex)
        srcIndex++;
      srcList.splice(srcIndex, 1);
      return true;
    };
    $scope.onSwap = function(srcList, srcIndex, targetList, targetIndex) {
      if (targetList === $scope.options.items) {
        targetList.splice(targetIndex, 0, srcList[srcIndex]);
        if (srcList == targetList && targetIndex <= srcIndex)
          srcIndex++;
        srcList.splice(srcIndex, 1);
        return true;
      }
      var swapList = _.clone(targetList);
      if (swapList.length) {
        var i;
        for (i = 0; i < swapList.length; i++) {
          targetList.splice(0, 1);
        }
      }
      targetList.splice(0, 0, srcList[srcIndex]);
      if (srcList == targetList && targetIndex <= srcIndex)
        srcIndex++;
      srcList.splice(srcIndex, 1);
      if (swapList.length) {
        var i;
        for (i = 0; i < swapList.length; i++) {
          srcList.push(swapList[i]);
        }
      }
      return true;
    };
    $scope.models = {
      selected: null,
      lists: {
        "originals": $scope.originals,
        "options": $scope.options,
        "translations": $scope.translations
      }
    };
    $scope.$watch('models', function(model) {
      $scope.modelAsJson = angular.toJson(model, true);
    }, true);
  }));
  ;
  return {};
});

